import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { resetStore } from '../../reduxStore/store';

const Header = ({shouldShowHeader}) => {
    
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const menuContainerRef = useRef(null);

    const handleLogoClick = () => {
        // Get user data from localStorage
        const userData = localStorage.getItem('user');
        if (userData) {
            try {
                const user = JSON.parse(userData);
                const roleID = user?.roleID;
                
                if (roleID === 1) {
                    // Admin user - navigate to dashboard with Reports tab
                    navigate('/configure/dashboard');
                    setTimeout(() => {
                        const reportsTab = document.getElementById('home-tab');
                        if (reportsTab) reportsTab.click();
                    }, 100);
                } else if (roleID === 2) {
                    // Branch Manager - navigate to branch-manager with Appointments tab
                    navigate('/configure/branch-manager');
                    setTimeout(() => {
                        const appointmentTab = document.getElementById('appointment-tab');
                        if (appointmentTab) appointmentTab.click();
                    }, 100);
                } else {
                    // Default fallback
                    navigate('/configure/dashboard');
                }
            } catch (error) {
                console.error('Error parsing user data:', error);
                // navigate('/configure/dashboard');
            }
        } else {
            // No user data, navigate to default
            navigate('/configure/login');
        }
    };

    const handleLogout = () => {
        setIsMenuOpen(false);
        // Clear any stored auth tokens or user data
        sessionStorage.removeItem('userData');
        localStorage.removeItem('user');
        dispatch(resetStore());
        // Redirect to login page
        navigate('/configure/login');
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    useEffect(() => {
        if (!shouldShowHeader) {
            setIsMenuOpen(false);
        }
    }, [shouldShowHeader]);

    useEffect(() => {
        setIsMenuOpen(false);
    }, [location.pathname]);

    useEffect(() => {
        if (!isMenuOpen) return;

        const handlePointerDown = (event) => {
            const container = menuContainerRef.current;
            if (!container) return;
            if (!container.contains(event.target)) {
                setIsMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handlePointerDown);
        document.addEventListener('touchstart', handlePointerDown);

        return () => {
            document.removeEventListener('mousedown', handlePointerDown);
            document.removeEventListener('touchstart', handlePointerDown);
        };
    }, [isMenuOpen]);

    return (
        <div style={{ 
            position: 'sticky',
            top: 0,
            zIndex: 1000,
            backgroundColor: '#fff', 
            padding: '15px 30px', 
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        }}>
            {/* Left side - Logo */}
            <div>
                <div className='cursor-pointer'
                    onClick={handleLogoClick} 
                    style={{ cursor: 'pointer' }}
                    aria-label="TruGreen"
                >
                    <img 
                        src="/images/logo.svg" 
                        alt='TruGreen_logo' 
                        style={{ 
                            height: '40px',
                            // filter: 'brightness(0) invert(1)' // Makes logo white
                        }}
                    />
                </div>
            </div>

            {/* Right side - User Menu */}
            {shouldShowHeader && (
            <div ref={menuContainerRef} style={{ position: 'relative' }}>
                <button 
                    onClick={toggleMenu}
                    style={{
                        backgroundColor: 'transparent',
                        border: '1px solid #ddd',
                        borderRadius: '50%',
                        padding: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '44px',
                        height: '44px',
                        cursor: 'pointer'
                    }}
                >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                </button>
                
                {isMenuOpen && (
                    <div style={{
                        position: 'absolute',
                        top: '100%',
                        right: 0,
                        marginTop: '5px',
                        backgroundColor: '#fff',
                        border: '1px solid #ddd',
                        borderRadius: '5px',
                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                        minWidth: '150px',
                        zIndex: 1000,
                        cursor: 'pointer'
                    }}>
                        <button 
                            onClick={handleLogout}
                            style={{
                                width: '100%',
                                padding: '10px 15px',
                                border: 'none',
                                backgroundColor: 'transparent',
                                textAlign: 'left',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                color: '#dc3545',
                                cursor: 'pointer'
                            }}
                            onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                        >
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                                <polyline points="16 17 21 12 16 7"></polyline>
                                <line x1="21" y1="12" x2="9" y2="12"></line>
                            </svg>
                            Logout
                        </button>
                    </div>
                )}
            </div>
            )}
        </div>
    );
};

export default Header;